export * from "./templates";
export * from "./images";
export * from "./useLocalStorageState";
export * from "./formating";

export const DE_FRONT_END_URL = "https://kyzzen.io/";
